module.exports = __webpack_public_path__ + "static/media/Simplify Communication.c9dbf89d.png";